/* eslint-disable no-undef */
import { useState } from 'react';
import { DeleteProject } from '../../services/seenapse';

export default function useDelete() {
  const [loading, setLoading] = useState(false);

  const onDeleteProject = ({ uid, callback }) => {
    setLoading(true);
    DeleteProject(uid)
      .then(() => callback())
      .catch(error => console.error(error))
      .finally(() => setLoading(false));
  };

  const copy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log('Text copied');
      })
      .catch((err) => {
        console.error('Copy failed!: ', err);
      });
  };

  return { onDeleteProject, copy, loading };
}



// WEBPACK FOOTER //
// ./src/app/projects/useDelete.js